
import { Reducer } from 'redux';
import { STATE } from 'app/constants';
import { mergeReducers } from 'app/infrastructure/redux/merge-reducers';
import { withOptionsReducer } from 'app/components/options-handler';
import { ExperienceTransferState } from './types-store';
import { reducer as experienceTransferListReducer, INITIAL_STATE as experienceTransferListState } from './list/reducers';
import { reducer as experienceTransferFormReducer, INITIAL_STATE as experienceTransferFormState } from './form/reducers';
import { reducer as experienceTransferOperationsReducer, INITIAL_STATE as experienceTransferOperationsmState } from './operations/reducers';

export const INITIAL_STATE: ExperienceTransferState = {
  list: experienceTransferListState,
  form: experienceTransferFormState,
  operations: experienceTransferOperationsmState
};

export const reducer: Reducer<ExperienceTransferState> = withOptionsReducer(
  STATE.experienceTransfer,
  mergeReducers({
    list: experienceTransferListReducer,
    form: experienceTransferFormReducer,
    operations: experienceTransferOperationsReducer
  })
);
